// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"321":"component---src-pages-list-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"321":"f98ceddc8c071a17e892","678":"edb8bae1c2b261b6b724","883":"447694caef5404bddc62"}[chunkId] + ".js";
};